import Backbone from "backbone";
import PromisedSyncHoc from "scripts/hoc/promisedSyncHoc";

class CurrentLocationLocalStorageModel extends PromisedSyncHoc(Backbone.Model) {
  constructor(attributes, options) {
    super(attributes, options);

    this.localStorage = new Backbone.LocalStorage(
      (options && options.storageName) || "currentLocationLocalStorage",
    );
  }
}

export default CurrentLocationLocalStorageModel;
